var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid px-0",attrs:{"id":"video"}},[_c('div',{staticClass:"main no-side-bar"},[_c('MainVideoWrapper')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }